import { Paper, TableContainer, Toolbar, Typography } from '@material-ui/core'
import { useEffect, useState } from 'react'
import Pagination from '@mui/material/Pagination'

import getCoownersByCoproId from './api'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableBody from '@mui/material/TableBody'
import { ItemList } from './components/ItemList'
import Table from '@mui/material/Table'

export const CoownersList = ({ copro_id }) => {
  const [coowners, setCoowners] = useState([])
  const [page, setPage] = useState(1)
  const fetchData = async () => {
    const res = await getCoownersByCoproId(copro_id)
    if (res.status === 200) {
      setCoowners(() => {
        return res.data
      })
    }
  }
  useEffect(() => {
    fetchData()
  }, [copro_id])
  return (
    <>
      <TableContainer component={Paper}>
        <Toolbar
          sx={{
            pl: { sm: 2 },
            pr: { xs: 1, sm: 1 },
          }}
        >
          <Typography
            sx={{ flex: '1 1 100%' }}
            variant="h6"
            id="tableTitle"
            component="div"
          >
            Copropriétaires
          </Typography>
        </Toolbar>
        <Table sx={{ minWidth: 650 }} size="small">
          <TableHead>
            <TableRow>
              <TableCell>Copropriétaire</TableCell>
              <TableCell>Lots</TableCell>
              <TableCell align="left"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {coowners.length > 0 &&
              coowners.map((coowner) => (
                <ItemList
                  key={coowner.id}
                  coowner={coowner}
                  refresh={fetchData}
                />
              ))}
          </TableBody>
        </Table>
        <Pagination
          sx={{
            padding: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
          count={1}
          color="primary"
          page={page}
          onChange={(event, value) => {
            setPage(value)
          }}
        />
      </TableContainer>
    </>
  )
}

export default CoownersList
